"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxShadows = void 0;

var _swatches = require("./colors/swatches");

var boxShadows = {
  small: "0 1px 3px 0 rgba(".concat(_swatches.monochrome.black_rgba, ", 0.15)"),
  smallInverse: "0 -1px 3px 0 rgba(".concat(_swatches.monochrome.black_rgba, ", 0.15)"),
  large: "0 2px 6px 0 rgba(".concat(_swatches.monochrome.black_rgba, ", 0.15)"),
  largeInverse: "0 -2px 3px 0 rgba(".concat(_swatches.monochrome.black_rgba, ", 0.15)")
};
exports.boxShadows = boxShadows;
//# sourceMappingURL=boxShadows.js.map